import { useMemo, useState } from 'react';

import { Native } from '@givebacks/api';
import { useShowCauseW_Selector } from 'core/Api';
import { ContactOrganizerModal, ShareModal } from 'core/Components';
import { usePlatformService } from 'core/Hooks';
import { BASE_URL } from 'core/Utils';
import { useNavigate } from 'react-router-dom';
import { Box, Card, Group, ImageMantine, KebabMenu, Text } from 'ui';

const StoreHeader = ({ uuid, productCount }: { uuid: string; productCount?: number }) => {
  const { data: storeCause } = useShowCauseW_Selector({ uuid });
  const [isContactModalOpen, setIsContactModalOpen] = useState(false);
  const [isShareModalOpen, setIsShareModalOpen] = useState(false);
  const navigate = useNavigate();
  const Platform = usePlatformService();

  const isContactSellerEnabled = useMemo(() => {
    if (Platform.isNative) {
      return Native.hasContactSeller;
    } else {
      return true;
    }
  }, [Platform.isNative]);

  if (!storeCause) return null;
  return (
    <>
      <Card bd="1px solid gray.1" p="lg">
        <Group justify="space-between" wrap="nowrap">
          <Group wrap="nowrap">
            <ImageMantine
              radius={12}
              w={48}
              style={{ aspectRatio: 1 / 1 }}
              src={storeCause?.logo?.url}
            />
            <Box>
              <Text fz="xs" fw={600}>
                {storeCause?.name}
              </Text>
              <Text fz="xxxs">{productCount} products</Text>
            </Box>
          </Group>
          <Group gap="xs" wrap="nowrap" justify="flex-end" flex={1}>
            {/* TODO: implement favoriting cause in final version @acdodd17 */}
            <KebabMenu
              items={[
                {
                  label: 'Visit Cause Page',
                  onClick: () => void navigate(`/causes/${storeCause.uuid}`),
                },
                { label: 'Share Cause Store', onClick: () => setIsShareModalOpen(true) },
                {
                  label: 'Contact Seller',
                  onClick: () => setIsContactModalOpen(true),
                  // TODO: Remove once the new native app is released with contact seller support
                  // Do not show this option for the native apps unless they have contact seller support
                  visible: isContactSellerEnabled,
                },
              ]}
              buttonProps={{ variant: 'gray', color: 'gray', size: 'sm' }}
            />
          </Group>
        </Group>
      </Card>
      <ContactOrganizerModal
        title="Contact Seller"
        causeId={storeCause.uuid}
        opened={isContactModalOpen}
        onClose={() => setIsContactModalOpen(false)}
      />
      <ShareModal
        opened={isShareModalOpen}
        onClose={() => setIsShareModalOpen(false)}
        causeName={storeCause.name}
        imgSrc={storeCause.logo?.url}
        link={`${BASE_URL}/shop/stores/${storeCause.uuid}`}
      />
    </>
  );
};

export { StoreHeader };
